import  React from "react";
import { connect } from "react-redux";
import {
    requestConsultationsPractitioner,
    searchConsultationsPractitioners,
} from "../../actions/consultations.action";

import { requestProfilPractitioner } from "../../actions/practitioners.action";
import { Col, Container, Row } from "shards-react";
import PageTitle from "../../components/common/PageTitle";
import {ConsultationTable} from "../../components/tables/ConsultationTable";

class Consultations extends React.Component
{
    constructor(props) {
        super(props);
        let uuid = this.props.match.params.id;
        this.props.loadData(uuid);
        if (this.props.practitioners.data.length <= 0) {
            this.props.loadPractitioner(uuid);
        }
    }

    render() {
        return (
            <Container fluid className="main-content-container px-4">
                {this.props.consultations.fetching || this.props.practitioners.fetching ? (
                    <div className="flex-center">
                        <div className="text-center d-block">
                            <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div>
                        <Row noGutters className="page-header py-4">
                            <PageTitle title={this.props.practitioners.data.first_name + ' ' + this.props.practitioners.data.last_name} subtitle="Consultations effectuées"
                                       className="text-sm-left mb-3"/>
                        </Row>
                        <Row>
                            <Col className="col-lg lg-12 mb-12 col-lg-12 mb-12">
                                <ConsultationTable
                                    parent={'practitioners'}
                                    research={this.props.consultations.searching}
                                    dataSearch={searchConsultationsPractitioners}
                                    entity={'practitioner'}
                                    selected={this.props.practitioners.data.id}
                                />
                            </Col>
                        </Row>
                    </div>
                )}
            </Container>

        );
    }
}

function mapStateToProps(state) {
    return {
        practitioners: state['practitioners'],
        consultations: state['consultations'],
    };
}

const mapDispatchToProps = dispatch => ({
    loadData: (uuid) => dispatch(requestConsultationsPractitioner(uuid)),
    loadPractitioner: (uuid) => dispatch(requestProfilPractitioner(uuid))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Consultations);



// WEBPACK FOOTER //
// ./src/views/Practitioners/Consultations.js